import React, { useContext } from "react";
import { store } from "../store.js";

const useSetDependencies = () => {
  const globalState = useContext(store);

  const setDependencies = (currentControlId, item,  dependencies) => {
    if (currentControlId != item.id) { //|| (type != "properties" && menuItem != "text" )
        
      const menuText = item["properties"]["text"]
      if (!menuText.option || menuText.option == globalState.state.formData.actions.option.text) {
        
        let textItem = item.properties.text
        if(textItem.relationShipValue && textItem.relationShipValue.includes(currentControlId)) {
          
          dependencies.push({globalId:item.globalId,id:item.id, isProperty:true, type:"properties", menu:"text"
          , relationShipProperty : { value : textItem.relationShipValue}, properties: item.properties})
        }
      }
      
        getItemConditions(item).filter(condition => {
          condition.values.values.map(data =>  
            data.details.map(detail => {
              if (!isAlreadyAdded(data.id, dependencies, condition)) { //if (!alreadyAddedsConditions.includes(data.id)) {
                
                let isFirstOperandRelationData = isReferenceValue(detail.firstOperand.value) && detail.firstOperand.value.includes(currentControlId)
                let isSecondOperandRelationData = isReferenceValue(detail.secondOperand.value) && detail.secondOperand.value.includes(currentControlId)
                //if (detail.firstOperand.value.includes(currentControlId)) alert(1)
                if (isFirstOperandRelationData || isSecondOperandRelationData){
                  dependencies.push({globalId:item.globalId, id:item.id, isProperty:condition.isProperty, type:condition.type, menu:condition.menu
                    , condition : data, properties: item.properties})
                }
              }
              //alreadyAddedsConditions.push(data.id)
            })
          )
        })

        
      //}
      
    }
  }

  const getItemConditions = (item) => {
    var conditions = []
    Object.entries(item.properties).map(([menu, value], index) => {
      let currentCondition = item.properties[menu].conditions
     if (globalState.state.formData.actions.option.condition == item.properties[menu].option
      && currentCondition) conditions.push({...currentCondition, isProperty:true, type:"properties", menu:menu})
    })
    Object.entries(item.styles).map(([menu, value], index) => {
      let currentCondition = item.styles[menu].conditions
     if ( globalState.state.formData.actions.option.condition == item.styles[menu].option
       && currentCondition) conditions.push({...currentCondition, isProperty:false, type:"styles", menu:menu})
    })
     
    return conditions
  }

  const isAlreadyAdded = (id, dependencies, condition) => {
    return dependencies.filter(item => id == item.id && item.type == condition.type && item.menu == condition.menu ).length>0 
  }
  
  const isReferenceValue = (value) => {
    return Array.isArray(value)
  };

  return setDependencies;
};

export default useSetDependencies;
